var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroDotsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 108 24",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.857,
    cy: 3.428,
    r: 3.429,
    transform: "rotate(180 18.857 3.428)",
    fill: "#FFF7F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.571,
    cy: 21.426,
    r: 2.571,
    transform: "rotate(180 2.571 21.426)",
    fill: "#FFF7F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.286,
    cy: 21.426,
    r: 2.571,
    transform: "rotate(180 88.286 21.426)",
    fill: "#FFF7F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.714,
    cy: 13.713,
    r: 1.714,
    transform: "rotate(180 37.714 13.713)",
    fill: "#ACB5C2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.143,
    cy: 15.424,
    r: 1.714,
    transform: "rotate(180 77.143 15.424)",
    fill: "#D4DAE1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.858,
    cy: 6.854,
    r: 1.714,
    transform: "rotate(180 54.858 6.854)",
    fill: "#748499"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.286,
    cy: 12.002,
    r: 1.714,
    transform: "rotate(180 106.286 12.002)",
    fill: "#ACB5C2"
  })));
}
export default __webpack_public_path__ + "fonts/hero-dots-right-2b1ee311e26d64e7b005fb2fe78dfda0.svg";
export { SvgHeroDotsRight as ReactComponent };